module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4AQMAAACSSKldAAAAAXNSR0IArs4c6QAAAAZQTFRFAAAAfX6ApUqVlAAAAAF0Uk5TAEDm2GYAAAA4SURBVBjTY2AgAPj/g8AHDJoPLFtAOs38//D/A8g0w2EGimg084h3x3+ovv8k6aOWfjQaVzgTAAAOOmHJdWWFFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/graphicNavigation-icon.png
// module id = lI0k
// module chunks = 243